export { ErrorBoundary } from './error-boundary';
export { ErrorBoundary as default } from './error-boundary';
